import gql from "graphql-tag";

export const allCompaniesQuery = gql`
  query allCompanies {
    allCompanies {
      id
      name
    }
  }
`;

export const companiesQuery = gql`
  query companies($filters: Filter, $page: Int, $perPage: Int) {
    companies(
      orderBy: { column: "createdAt", direction: desc }
      filters: $filters
      page: $page
      first: $perPage
    ) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        name
        isActive
        taxNumber
        manager {
          name
          oneCId
        }
        customer {
          name
          bonusProgramLevel {
            name
          }
        }
      }
    }
  }
`;

export const allCustomersQuery = gql`
  query allCustomer($filters: Filter) {
    allCustomer(filters: $filters) {
      id
      name
    }
  }
`;
